module.exports = __webpack_public_path__ + "static/media/s5.a9c31a97.jpg";